import { AxiosInstance, AxiosPromise, AxiosRequestConfig } from 'axios';
import IBusyApiWrapper from 'types/BusyApiWrapper';
import { ICreateSignUpEvent, ISignUpEvent } from 'types/SignUpEvent';

export default function createSignUpEventRestService(client: AxiosInstance) {
  return {
    post: (params: ICreateSignUpEvent, config?: AxiosRequestConfig): AxiosPromise<IBusyApiWrapper<ISignUpEvent>> => {
      return client.post('/sign-up-event', params, config);
    },
  };
}
